import { render, staticRenderFns } from "./ModelPlace.vue?vue&type=template&id=c0d97dbc&scoped=true"
import script from "./ModelPlace.vue?vue&type=script&lang=js"
export * from "./ModelPlace.vue?vue&type=script&lang=js"
import style0 from "./ModelPlace.vue?vue&type=style&index=0&id=c0d97dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d97dbc",
  null
  
)

export default component.exports